'use client';

import { FaCheckCircle } from 'react-icons/fa';
import { MdOutlineCancel } from 'react-icons/md';

import { comfortFeaturesCheckboxes, ListingPayload } from '@/slw/entities/seller/listing';

interface ListingFeaturesProps {
  listing: ListingPayload;
}

export function ListingFeatures({ listing }: ListingFeaturesProps) {
  return (
    <section className='px-6'>
      <h2 className='text-2xl font-bold mb-4'>Comfort & Features</h2>
      <ul
        className='block space-y-4 md:space-y-0 md:grid grid-cols-2 gap-x-4 px-4 gap-y-4 list-disc
      font-medium text-sm'
      >
        {comfortFeaturesCheckboxes.map((feature, idx) => {
          const hasFeature = listing[feature.name as keyof ListingPayload];

          return (
            <li key={idx} className='text-base'>
              <div className='flex items-center gap-2'>
                <span>{feature.label}</span>
                {hasFeature ? (
                  <FaCheckCircle className='text-green-600 w-4 h-4' />
                ) : (
                  <MdOutlineCancel className='text-destructive w-4 h-4' />
                )}
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
